module.exports = __webpack_public_path__ + "static/img/0001.52dd0a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/0001.png
// module id = cVoO
// module chunks = 1